import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from 'app/shared/config/constants';
import { Observable } from 'rxjs';

@Injectable ( {
  providedIn: 'root',
} )
export class VendorConfirmationService {

  readonly url = Constants.vendorConfirmationUrl;

  constructor ( private http: HttpClient ) {
  }

  confirm ( incidentId: string, data ): Observable<any> {
    return this.http.post<any> ( `${ this.url }?incidentId=${ incidentId! }`, data );
  }
}
